module.exports = __webpack_public_path__ + "static/media/powerball.afed990f.png";